import React from "react";
import CoordinatePlane from "./CoordinatePlane";

/* All three use the same 90×90 canvas, axes turned off */

export const OneIntersection = () => (
    <CoordinatePlane
    width={250}   // 90 * 1.3
    height={250}
      showAxes={true}
      disablePlot={true}  // <== turn off point‐clicking
      lines={[
        { start: [-4, -4], end: [4, 4],  color: "blue", strokeWidth: 2 },
        { start: [-4,  4], end: [4, -4], color: "red",  strokeWidth: 2 }
      ]}
    />
  );  

export const ZeroIntersection = () => (
  <CoordinatePlane
    width={250}
    height={250}
    showAxes={true}
    disablePlot={true}  // <== turn off point‐clicking
    lines={[
      { start: [-4, 2], end: [4, 2],  color: "blue", strokeWidth: 2 },
      { start: [-4,-1], end: [4,-1],  color: "red",  strokeWidth: 2 }
    ]}
  />
);

export const InfiniteIntersection = () => (
  <CoordinatePlane
    width={250}
    height={250}
    showAxes={true}
    disablePlot={true}  // <== turn off point‐clicking
    lines={[
      { start: [-4,-2], end: [4, 2],  color: "blue", strokeWidth: 2 },
      { start: [-4,-2], end: [4, 2],  color: "red",  strokeWidth: 2, dash: true }
    ]}
  />
);
